const scope = {
    name_exists: 'Имя области {{name}} уже используется',
    name_with_space: 'Имя области не может содержать пробелы.',
};
export default Object.freeze(scope);
